module.exports = __webpack_public_path__ + "9dc01cc11181bf3e32d141f91d4cc00d.png";